<p-table stripedRows #dataTable
    [value]="items"
    dataKey="id"
    editMode="row"
    [style]="{ width: '100%' }"
    (onRowSelect)="onRowSelect($event)"
    [(selection)]="selected"
    [scrollable]="true"
    [scrollHeight]="tableScrollHeight"
    size="small"
    selectionMode="single"
    [columns]="cols"
    exportFilename="contract">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item>
        <tr>
            <!-- Edit -->
            <th pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell"></th>
            <!-- Status-->
            <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                <i class="pi pi-exclamation-circle" title="Status"></i>
            </th>
            <!-- BudgetLock -->
            <th pFrozenColumn [frozen]="IsColumnFrozen" *featureFlag="'projectBudgetForecast'">
                <i class="pi pi-lock" style="font-size: 1.5em" title="Lock"></i>
            </th>
            <!-- Contract -->
            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Contractdesc">
                Contract
                <p-sortIcon field="Contractdesc" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                <p-columnFilter field="Contractdesc" matchMode="in" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                            [options]="contractFilterSelectItems" [filter]="true" (onChange)="
                            filter($event.value)
                        "></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Budget Cycle -->
            <th pSortableColumn="Budgetcycle">
                Budget Cycle
                <p-sortIcon field="Budgetcycle" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                <p-columnFilter field="Budgetcycle" matchMode="in" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                            [options]="BudgetCycles" [filter]="true" (onChange)="
                                    filter($event.value)
                                "></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Budget Level -->
            <th pSortableColumn="Budgetlevel">
                Budget Level
                <p-sortIcon field="Budgetlevel" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                <p-columnFilter field="Budgetlevel" matchMode="in" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                            [options]="BudgetLevels" [filter]="true" (onChange)="
                            filter($event.value)
                        "></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Budget End Date -->
            <th pSortableColumn="BudgetEndDate">
                Budget End
                <p-sortIcon field="BudgetEndDate" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Contract Value -->
            <th pSortableColumn="Contractvalue">
                Contract Value
                <p-sortIcon field="Contractvalue" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Contract Funding -->
            <th pSortableColumn="Contractfunding">
                Contract Funding
                <p-sortIcon field="Contractfunding" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Total Hours Budget -->
            <th pSortableColumn="Totalhoursbudget">
                CTD Hrs Budget
                <p-sortIcon field="Totalhoursbudget" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Total Hours Spent -->
            <th pSortableColumn="Totalhoursspent">
                CTD Hrs Spent
                <p-sortIcon field="Totalhoursspent" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Total Hours Variance -->
            <th pSortableColumn="Totalhoursvariance">
                CTD Hrs Variance
                <p-sortIcon field="Totalhoursvariance" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Total Amount Budget -->
            <th pSortableColumn="Totalamountbudget">
                CTD $ Budget
                <p-sortIcon field="Totalamountbudget" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Total Amount Spent -->
            <th pSortableColumn="Totalamountspent">
                CTD $ Spent
                <p-sortIcon field="Totalamountspent" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Total Amount Variance -->
            <th pSortableColumn="Totalamountvariance">
                CTD $ Variance
                <p-sortIcon field="Totalamountvariance" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
        <tr [pSelectableRow]="item" [pEditableRow]="item"
            data-id="row-{{ item.id }}" [ngClass]="{
                'ui-editing-row': edit && editing?.id === item?.id
            }">
            <!-- Edit -->
            <td pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell">
                <button
                    class="edit-button"
                    title="Edit"
                    *ngIf="
                        !disabled &&
                        !edit &&
                        (!editing?.id || editing?.id === item?.id)
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    rounded
                    text
                    (click)="onRowEditInit(item)">
                </button>
                <button class="edit-save-button" title="Save" *ngIf="edit && !disabled" pButton type="button" pSaveEditableRow
                    icon="pi pi-check" class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditSave(item)"></button>
                <button class="edit-cancel-button" title="Cancel" *ngIf="edit && !disabled" pButton type="button" pCancelEditableRow
                    icon="pi pi-times" class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(item)"></button>
            </td>
            <!-- Status-->
            <td pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"></ef-status-icon>
                </div>
            </td>
            <!-- BudgetLock-->
            <td pFrozenColumn [frozen]="IsColumnFrozen" *featureFlag="'projectBudgetForecast'">
                <div (click)="onLockClick(item)">
                    <i [ngClass]="{
                            pi: true,
                            'pi-lock': item.BudgetLock,
                            'pi-unlock': !item.BudgetLock,
                            green: !item?.BudgetLock,
                            red: item?.BudgetLock
                        }" style="font-size: 1.5em" title="Lock"></i>
                </div>
            </td>
            <!-- Contract -->
            <td pFrozenColumn [frozen]="IsColumnFrozen" [title]="item?.Contractdesc">
                {{ item?.Contractdesc }}
            </td>
            <!-- Budget Cycle -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-dropdown [items]="BudgetCycles" [rowData]="item" property="Budgetcycleid"></ef-dropdown>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                        (
                        BudgetCycles
                        | itemlookup: 'value':item?.Budgetcycleid
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        (
                        BudgetCycles
                        | itemlookup: 'value':item?.Budgetcycleid
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        (
                        BudgetCycles
                        | itemlookup: 'value':item?.Budgetcycleid
                        )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Budget Level -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-dropdown [items]="BudgetLevels" [rowData]="item" property="Budgetlevelid"></ef-dropdown>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                        (
                        BudgetLevels
                        | itemlookup: 'value':item?.Budgetlevelid
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        (
                        BudgetLevels
                        | itemlookup: 'value':item?.Budgetlevelid
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        (
                        BudgetLevels
                        | itemlookup: 'value':item?.Budgetlevelid
                        )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Budget End Date -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-calendar [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"
                            [(ngModel)]="item.BudgetEndDate" appendTo="body"></p-calendar>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                        moment(item?.BudgetEndDate).isValid()
                        ? moment(item?.BudgetEndDate).format(
                        'MM/DD/YYYY'
                        )
                        : null
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        moment(item?.BudgetEndDate).isValid()
                        ? moment(item?.BudgetEndDate).format(
                        'MM/DD/YYYY'
                        )
                        : null
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Contract Value -->
            <td class="currency">
                {{ item?.Contractvalue | currency }}
            </td>
            <!-- Contract Funding -->
            <td class="currency">
                {{ item?.Contractfunding | currency }}
            </td>
            <!-- Total Hours Budget -->
            <td>
                {{ item?.Totalhoursbudget }}
            </td>
            <!-- Total Hours Spent -->
            <td>
                {{ item?.Totalhoursspent }}
            </td>
            <!-- Total Hours Variance -->
            <td [ngClass]="{
                    'alert-danger': item?.Totalhoursvariance < 0,
                    alert: item?.Totalhoursvariance < 0
                }">
                {{ item?.Totalhoursvariance?.toFixed(2) }}
            </td>
            <!-- Total Amount Budget -->
            <td class="currency">
                {{ item?.Totalamountbudget | currency }}
            </td>
            <!-- Total Amount Spent -->
            <td class="currency">
                {{ item?.Totalamountspent | currency }}
            </td>
            <!-- Total Amount Variance -->
            <td class="currency" [ngClass]="{
                    'alert-danger': item?.Totalamountvariance < 0,
                    alert: item?.Totalamountvariance < 0
                }">
                {{ item?.Totalamountvariance | currency }}
            </td>
        </tr>
    </ng-template>
</p-table>
